import { Card, CardBody } from '@components/card/card';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import { useAppDispatch } from '@store/hooks';
import { addPerAccrualBalance } from '@store/HR/Person/PersonAccrualBalanceSlice';
import { useFormik } from 'formik';
import { useState } from 'react';
import { Alert, Form } from 'react-bootstrap';
// import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

// مكون إضافة رصيد الإجازات (للمودال)

// مكون إضافة رصيد الإجازات (للمودال)

// تعريف الـ Types
interface VacationBalanceForm {
  personId: string;
  value: string;
  increaseFlag: boolean;
  startDate: string;
  endDate: string;
  description: string;
}

interface AddVacationBalanceProps {
  personId: string;
  onSuccess: () => void;
  onCancel: () => void;
}

interface VacationBalanceAPIRequest {
  personId: string;
  value: number;
  increaseFlag: boolean;
  startDate: string;
  endDate: string;
  description: string;
}

interface APIResponse {
  payload?: {
    succeeded: boolean;
    message?: string;
    data?: any;
  };
}

 

const AddVacationBalance: React.FC<AddVacationBalanceProps> = ({ personId, onSuccess, onCancel }) => {
  const dispatch = useAppDispatch();
  const [showSuccess, setShowSuccess] = useState<boolean>(false);
  const [currentBalance, setCurrentBalance] = useState<number>(15); // افتراضي - استبدل بالـ API

  const formik = useFormik<VacationBalanceForm>({
    initialValues: {
      personId: personId,
      value: '',
      increaseFlag: true,
      startDate: '',
      endDate: '',
      description: ''
    },

    validationSchema: yup.object({
      value: yup
        .number()
        .required('القيمة مطلوبة')
        .positive('يجب أن تكون القيمة موجبة')
        .min(0.5, 'يجب أن تكون القيمة 0.5 يوم على الأقل')
        .max(365, 'لا يمكن أن تتجاوز القيمة 365 يوم'),
      startDate: yup
        .date()
        .required('تاريخ البداية مطلوب')
        .min(new Date().toISOString().split('T')[0], 'لا يمكن أن يكون تاريخ البداية في الماضي'),
      endDate: yup
        .date()
        .required('تاريخ النهاية مطلوب')
        .min(yup.ref('startDate'), 'يجب أن يكون تاريخ النهاية بعد تاريخ البداية'),
      description: yup
        .string()
        .required('الوصف مطلوب')
        .min(5, 'يجب أن يكون الوصف 5 أحرف على الأقل')
        .max(500, 'لا يمكن أن يتجاوز الوصف 500 حرف')
    }),

    onSubmit: async (values, { setSubmitting, resetForm }) => {
      try {
        // التحقق من الرصيد في حالة الخصم
        if (!values.increaseFlag && Number(values.value) > currentBalance) {
          formik.setFieldError('value', 'رصيد غير كافي لهذه العملية');
          setSubmitting(false);
          return;
        }

        const response = await dispatch(
          addPerAccrualBalance({
            personId: values.personId,
            value: Number(values.value),
            increaseFlag: values.increaseFlag,
            startDate: values.startDate,
            endDate: values.endDate,
            description: values.description
          })
        );

        if (response?.payload?.succeeded === true) {
          setShowSuccess(true);

          // حساب الرصيد الجديد للمستخدم
          const newBalance = values.increaseFlag
            ? currentBalance + Number(values.value)
            : currentBalance - Number(values.value);

          setCurrentBalance(newBalance);

          setTimeout(() => {
            setShowSuccess(false);
            resetForm();
            onSuccess();
          }, 2000);
        } else {
          CustomAlert({
            action: 'Error',
            msg: response?.payload?.message || 'حدث خطأ أثناء الحفظ'
          });
        }
      } catch (error) {
        console.error('Save error:', error);
        const errorMessage = error instanceof Error ? error.message : 'حدث خطأ أثناء الحفظ';
        CustomAlert({
          action: 'Error',
          msg: errorMessage
        });
      } finally {
        setSubmitting(false);
      }
    }
  });

  // حساب الرصيد المتوقع بعد العملية
  const calculateProjectedBalance = (): number => {
    if (!formik.values.value) return currentBalance;

    const value = Number(formik.values.value);
    return formik.values.increaseFlag ? currentBalance + value : currentBalance - value;
  };

  // التحقق من التاريخ التلقائي
  const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const value = e.target.value;
    formik.setFieldValue('startDate', value);

    // إذا كان تاريخ النهاية فارغاً أو قبل تاريخ البداية، تعيينه بنفس تاريخ البداية
    if (!formik.values.endDate || formik.values.endDate < value) {
      formik.setFieldValue('endDate', value);
    }
  };

  const handleOperationTypeChange = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    const isIncrease = e.target.value === 'true';
    formik.setFieldValue('increaseFlag', isIncrease);

    // إعادة تعيين رسائل الخطأ عند تغيير نوع العملية
    if (formik.errors.value) {
      formik.setFieldError('value', '');
    }
  };

  const projectedBalance = calculateProjectedBalance();
  const isDecrease = !formik.values.increaseFlag;
  const hasInsufficientBalance = isDecrease && Number(formik.values.value) > currentBalance;

  return (
    <div className='p-3'>
      {/* بطاقة الرصيد الحالي */}
      <Card className='bg-secondary bg-opacity-50 border-0 mb-4'>
        <CardBody className='py-3'>
          <div className='row text-center'>
            <div className='col-6'>
              <div className='border-end'>
                <h4 className={`mb-1 ${hasInsufficientBalance ? 'text-danger' : 'text-theme'}`}>{currentBalance}</h4>
                <small className='text-muted'>الرصيد الحالي</small>
              </div>
            </div>
            <div className='col-6'>
              <div>
                <h4
                  className={`mb-1 ${
                    projectedBalance < 0
                      ? 'text-danger'
                      : projectedBalance > currentBalance
                      ? 'text-success'
                      : 'text-warning'
                  }`}
                >
                  {projectedBalance}
                </h4>
                <small className='text-muted'>الرصيد المتوقع</small>
              </div>
            </div>
          </div>
          {hasInsufficientBalance && (
            <div className='text-center mt-2'>
              <small className='text-danger'>
                <i className='fa fa-exclamation-triangle me-1'></i>
                رصيد غير كافي - لا يمكن تنفيذ هذه العملية
              </small>
            </div>
          )}
        </CardBody>
      </Card>

      {/* رسالة النجاح */}
      {showSuccess && (
        <Alert variant='success' className='d-flex align-items-center mb-4'>
          <i className='fa fa-check-circle fa-lg me-3 text-success'></i>
          <div>
            <h6 className='mb-1'>تم بنجاح</h6>
            <p className='mb-0'>تم إضافة رصيد الإجازات بنجاح</p>
          </div>
        </Alert>
      )}

      <Form>
        <div className='row mb-3'>
          <div className='col-md-6'>
            <div className='form-group mb-3'>
              <label className='form-label required'>
                القيمة
                <small className='text-muted ms-1'>(بالأيام)</small>
              </label>
              <div className='input-group'>
                <Form.Control
                  type='number'
                  step='0.5'
                  className='form-control'
                  name='value'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.value}
                  isInvalid={Boolean(formik.touched.value && formik.errors.value)}
                  placeholder='0.0'
                />
                <span className='input-group-text'>أيام</span>
              </div>
              <Form.Control.Feedback type='invalid'>{formik.errors.value}</Form.Control.Feedback>
              <div className='form-text'>يمكنك استخدام القيم العشرية لنصف الأيام (مثال: 2.5)</div>
            </div>
          </div>

          <div className='col-md-6'>
            <div className='form-group mb-3'>
              <label className='form-label required'>نوع العملية</label>
              <Form.Select
                className='form-select'
                name='increaseFlag'
                onChange={handleOperationTypeChange}
                value={formik.values.increaseFlag.toString()}
              >
                <option value={'true'}>
                  <i className='fa fa-plus-circle me-2 text-success'></i>
                  إضافة
                </option>
                <option value={'false'}>
                  <i className='fa fa-minus-circle me-2 text-danger'></i>
                  خصم
                </option>
              </Form.Select>
              <div className='form-text'>
                {formik.values.increaseFlag ? 'إضافة أيام إلى رصيد الإجازات' : 'خصم أيام من رصيد الإجازات'}
              </div>
            </div>
          </div>
        </div>

        <div className='row mb-3'>
          <div className='col-md-6'>
            <div className='form-group mb-3'>
              <label className='form-label required'>تاريخ البداية</label>
              <Form.Control
                type='date'
                className='form-control'
                name='startDate'
                onChange={handleStartDateChange}
                onBlur={formik.handleBlur}
                value={formik.values.startDate}
                isInvalid={Boolean(formik.touched.startDate && formik.errors.startDate)}
                min={new Date().toISOString().split('T')[0]}
              />
              <Form.Control.Feedback type='invalid'>{formik.errors.startDate}</Form.Control.Feedback>
            </div>
          </div>

          <div className='col-md-6'>
            <div className='form-group mb-3'>
              <label className='form-label required'>تاريخ النهاية</label>
              <Form.Control
                type='date'
                className='form-control'
                name='endDate'
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.endDate}
                isInvalid={Boolean(formik.touched.endDate && formik.errors.endDate)}
                min={formik.values.startDate || new Date().toISOString().split('T')[0]}
              />
              <Form.Control.Feedback type='invalid'>{formik.errors.endDate}</Form.Control.Feedback>
            </div>
          </div>
        </div>

        <div className='row mb-4'>
          <div className='col-12'>
            <div className='form-group mb-3'>
              <label className='form-label required'>
                الوصف
                <small className='text-muted ms-1'>({formik.values.description?.length || 0}/500)</small>
              </label>
              <Form.Control
                as='textarea'
                rows={3}
                className='form-control'
                name='description'
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.description}
                isInvalid={Boolean(formik.touched.description && formik.errors.description)}
                placeholder='مثال: تخصيص إجازة سنوية، خصم إجازة مرضية، إلخ...'
                maxLength={500}
              />
              <Form.Control.Feedback type='invalid'>{formik.errors.description}</Form.Control.Feedback>
              <div className='form-text'>اشرح سبب هذه العملية</div>
            </div>
          </div>
        </div>

        {/* ملخص العملية */}
        <Card className='border-warning bg-warning bg-opacity-10 mb-4'>
          <CardBody className='py-3'>
            <h6 className='text-warning mb-3'>
              <i className='fa fa-info-circle me-2'></i>
              ملخص العملية
            </h6>
            <div className='row small'>
              <div className='col-6'>
                <strong>الرصيد الحالي:</strong> {currentBalance} يوم
              </div>
              <div className='col-6'>
                <strong>العملية:</strong>
                <span className={formik.values.increaseFlag ? 'text-success' : 'text-danger'}>
                  {formik.values.increaseFlag ? ' +' : ' -'}
                  {formik.values.value || 0} يوم
                </span>
              </div>
              <div className='col-12 mt-2'>
                <strong>الرصيد الجديد:</strong>
                <span className={hasInsufficientBalance ? 'text-danger' : 'text-success'}> {projectedBalance} يوم</span>
              </div>
            </div>
          </CardBody>
        </Card>

        <div className='text-center border-top pt-3'>
          <button
            disabled={formik.isSubmitting || !formik.dirty || hasInsufficientBalance}
            type='button'
            className='btn btn-theme btn-lg px-5 me-3 rounded-2'
            onClick={() => formik.submitForm()}
          >
            {formik.isSubmitting ? (
              <>
                <i className='fa fa-spinner fa-spin fa-fw me-2'></i>
                جاري المعالجة...
              </>
            ) : (
              <>
                <i className={`fa fa-fw me-2 ${formik.values.increaseFlag ? 'fa-plus-circle' : 'fa-minus-circle'}`}></i>
                {formik.values.increaseFlag ? 'إضافة رصيد' : 'خصم رصيد'}
              </>
            )}
          </button>

          <button
            type='button'
            className='btn btn-outline-secondary btn-lg px-5 rounded-2'
            onClick={onCancel}
            disabled={formik.isSubmitting}
          >
            <i className='fa fa-times fa-fw me-2'></i>
            إلغاء
          </button>
        </div>
      </Form>
    </div>
  );
};
export default AddVacationBalance;
